import { render, staticRenderFns } from "./SplitEllipsis.vue?vue&type=template&id=6453bc22"
import script from "./SplitEllipsis.vue?vue&type=script&lang=js"
export * from "./SplitEllipsis.vue?vue&type=script&lang=js"
import style0 from "./SplitEllipsis.vue?vue&type=style&index=0&id=6453bc22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports